export const prepareRequestKey = ({method, url}) => `${method}:${url}`;


// WEBPACK FOOTER //
// ./src/reducers/utils/apiResources/prepareRequestKey.js